import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('VatFilterController', VatFilterController);

    function VatFilterController($scope) {
        var vm = this;

        init();

        function init() {
            vm.vatRates = [0, 5, 8, 23];
            $scope.$watch(
                function () {
                    return vm.vatRate;
                },
                function () {
                    if (vm.vatRate !== undefined) {
                        vm.vatRate = +vm.vatRate;
                    }
                }
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/filters/vat-filter/vat-filter.controller.ts